import React, { useState, useEffect } from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import { validateEmail } from '../../utils/validators'

import DispatcherService from '../../services/DispatcherService'

import View from '../form/View'
import Header from '../form/Header'
import InputField from '../form/InputField'
import Footer from '../form/Footer'
import Loader from '../form/Loader'
import ReserveError from './ReserveError'

const useStyles = createUseStyles(theme => ({
  root: {
    height: '100%',
    flexDirection: 'column',
    flex: 1
  },
  content: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '0 36px'
  }
}))

function ReserveView (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })
 
  const [ email, setEmail ] = useState()
  const [ error, setError ] = useState(false)
  const [ fetching, setFetching ] = useState(false)
  const [ fetchError, setFetchError ] = useState(false) 

  useEffect(() => {
    if (fetching) {
      let key
      if (props.private) {
        const inviteKey = DispatcherService.getInviteKey()
        key = inviteKey ? { inviteKey } : { email }
      } 

      DispatcherService.reserve(key)
        .then(reserveId => props.next({ reserveId, ...key }))
        .catch(err => {
          console.error(err)
          setFetchError(err)
          setFetching(false)
        })
    }
  }, [ fetching ])

  useEffect(() => {
    if ((props.private && DispatcherService.getInviteKey()) || !props.private) {
      setFetching(true)
    }
  }, [ props.private ])

  const submit = async () => {
    if (validateEmail(email)) {
      setFetching(true)
    } else {
      setError('E-mail inválido')
    }
  }

  if (fetchError) {
    const message = props.private ? 
      'Desculpe, mas você não consta na lista de convidados ou seu convite já foi usado! =(' :
      'Desculpe, mas o evento excedeu o número de convidados... =('
    return <ReserveError 
      statusCode={fetchError.status}
      message={message}
      next={props.back}
      timeout={6000}
    />
  }

  if (props.private && !DispatcherService.getInviteKey()) {
    return (
      <View className={styles.root}>
        <Header 
          title={"Precisamos verificar o seu e-mail antes de continuar"}
          index={props.index} 
          numOfSteps={props.numOfSteps} 
          showMarkers={true}
        />
        <View className={styles.content}>
          { fetching ? (
            <Loader message="Estamos verificando o seu e-mail..." />
          ) : (
            <InputField 
              type="text"
              label='E-mail'
              name="email"
              error={error}
              onChange={e => setEmail(e.target.value)}
            />
          )}
        </View>
        <Footer 
          onBack={() => props.back()}
          onNext={submit}
          disabled={!email || email === ''} 
        />
      </View>
    )
  }

  return (
    <View className={styles.root}>
      <View className={styles.content}>
        <Loader message="Carregando" />
      </View>
      <Footer />
    </View>
  )
}

export default ReserveView